import $ from "jquery";
import * as Survey from "survey-react";
import { focusAndClearInputs } from "./utils";

export default function onAfterRenderQuestion(survey, q, t) {
  const question = q.question;
  let extraText = "";
  // add text for input ("Type below")
  if (question instanceof Survey.QuestionTextModel) {
    extraText = t("survey.common.type_below", { ns: "survey" });
  } else if (question instanceof Survey.QuestionRadiogroupModel) {
    // Create AriaLabelBy
    const elementlabelBy = document.querySelector(".sv-string-viewer");
    elementlabelBy.setAttribute("id", "qId");

    // Set AriaLabelBy
    document
      .querySelector("[role=radiogroup] .sv_qcbc, .sv_qcbc[role=radiogroup]")
      ?.setAttribute("aria-labelledby", "qId");
    document
      .querySelector("[role=radiogroup]")
      ?.setAttribute("aria-labelledby", "qId");

    // add text for radio buttons
    if (question.propertyHash.choices.length > 1) {
      extraText = t("survey.common.select_one", { ns: "survey" });
    }
  } else if (question instanceof Survey.QuestionCheckboxModel) {
    // add text for checkboxes
    const { maxSelectedChoices } = question.propertyHash;
    if (question.customWidgetValue?.name === "tagbox") {
      extraText = t("survey.common.type_below_to_add", { ns: "survey" });
    } else if (maxSelectedChoices) {
      extraText = t("survey.common.select_up_to", {
        amount: t(`survey.common.up_to_${maxSelectedChoices}`, {
          ns: "survey",
        }),
        ns: "survey",
      });
    } else {
      extraText = t("survey.common.select_all_apply", { ns: "survey" });
    }

    // remove aria-required and aria-invalid from role="group"
    if (q.htmlElement.getAttribute("role") === "group") {
      q.htmlElement.removeAttribute("aria-invalid");
      q.htmlElement.removeAttribute("aria-required");
    }
  }
  if (extraText) {
    const span = document.createElement("span");
    span.innerHTML = extraText;
    span.className = "sv_q_instructions";
    const firstDiv = q.htmlElement.children[0];
    firstDiv.insertAdjacentElement("afterend", span);
  }

  // add if missing <legend>
  if (
    question instanceof Survey.QuestionCheckboxModel ||
    question instanceof Survey.QuestionRadiogroupModel
  ) {
    const existingLegend = q.htmlElement.querySelector("legend");
    if (!existingLegend) {
      const elementLegend = document.createElement("legend");

      const elementLegendValue = document.createTextNode(
        document.querySelector(".sv-string-viewer").innerText
      );

      elementLegend?.appendChild(elementLegendValue);
      q.htmlElement.querySelector(".sv_qcbc")?.prepend(elementLegend);
    }
  }

  focusAndClearInputs(q.htmlElement, survey);

  // hacks to made "other" option working for radiogroup as designed
  // - input is already visible
  // - by making a focus on a field, it's like this option is selected
  // The hack is:
  // - to make this other option look differently - just like text input
  // - when it's clicked, it's replaced by text input
  if (
    (question instanceof Survey.QuestionRadiogroupModel ||
      question instanceof Survey.QuestionCheckboxModel) &&
    question.hasOther
  ) {
    /*
    document
      .querySelector(".sv_q_radiogroup_label")
      .setAttribute("tabIndex", "1");
      */
    q.htmlElement.querySelector("fieldset").classList.add("hasOther");

    const otherRadio = q.htmlElement.querySelector(
      ".sv_q_radiogroup:last-of-type,.sv_q_checkbox:last-of-type"
    );
    const otherRadioLabel = otherRadio?.querySelector("label");

    otherRadioLabel?.classList.add("labelOther");
    otherRadioLabel?.setAttribute("aria-label", otherRadioLabel.textContent);

    // move the radio label before and clear the label inside radio
    /*
    const span = document.createElement("span");
    span.innerHTML = otherRadioLabel.textContent;
    span.className = "sv_q_radiogroup_or";

    const span2 = document.createElement("span");
    span2.innerHTML = t("survey.common.or", { ns: "survey" });
    span2.className = "sv_q_radiogroup_or_line";
    span.insertAdjacentElement("afterbegin", span2);

    otherRadio.querySelector("span:last-child").style.display = "none";
    otherRadio.insertAdjacentElement("beforebegin", span);
    */
  }

  // tagbox handling
  if ("select2Config" in question) {
    const select2 = $(".select2").prev("select");
    let wasRemoved = false;
    let activeTab = null;
    if (select2.length) {
      if (select2[0].hasAttribute("multiple")) {
        $(".select2-search__field").attr(
          "aria-label",
          $(".sv_q_instructions").text()
        );
        $(".select2-search--inline").attr(
          "data-before",
          t("survey.common.type_below_to_add", { ns: "survey" })
        );
        // hide label
        $(".sv_q_instructions").remove();

        select2.on("select2:unselecting", function (e) {
          // prevent from removing form a list if already there (default - annoying select2 behavior)
          if (e.params.args.originalEvent === undefined) {
            e.preventDefault();
            setTimeout(function () {
              $(".select2 .select2-search__field").val("");
            }, 0);
          }
          if (e.params.args?.originalEvent?.type === "mouseup") {
            e.preventDefault();
            select2.select2("close");
          } else {
            wasRemoved = true;
            setTimeout(function () {
              wasRemoved = false;
            }, 100);
          }
          // remove focus from the field, when removed
          if (
            e.params.args?.originalEvent?.target.classList.contains(
              "select2-selection__choice__remove"
            )
          ) {
            setTimeout(function () {
              $(".select2 .select2-search__field")[0].blur();
            }, 0);
          }
        });

        select2.on("select2:opening", function (e) {
          // check for place between field and botom viewport
          const html = document.querySelector("html");
          const domRect = document
            .querySelector(".select2-search__field")
            ?.getBoundingClientRect();
          const spaceBelow = window.innerHeight - domRect.bottom;
          if (spaceBelow < 220) {
            // scroll bottom, so the dropdown appears below
            html.style.scrollBehavior = "auto";
            window.scrollTo({
              top: window.scrollY + (220 - spaceBelow),
              left: 0,
              behavior: "auto",
            });
            html.style.scrollBehavior = "smooth";
          }

          if (wasRemoved) {
            e.preventDefault();
          }

          if (activeTab?.className === "select2-selection__choice__remove") {
            e.preventDefault();
          }
        });

        // add a11y attr to close button
        const tags = document.querySelectorAll(
          '.select2-selection__choice__remove[role="presentation"]'
        );

        if (!!tags.length) {
          tags.forEach((tag) => {
            tag.setAttribute("role", "button");
            tag.setAttribute("tabindex", "0");
            tag.setAttribute("title", `${tag.parentElement.title} remove`);
          });
        }
      } else {
        // single value
        select2.on("select2:open", function (e) {
          $(".select2-search__field")[0].focus();
        });
      }

      $(".sv_q").on("keyup", function (e) {
        if (e.originalEvent.code === "Tab") {
          activeTab = e.target;
        }

        if (
          ["Space", "Enter"].includes(e.originalEvent.code) &&
          activeTab?.className === "select2-selection__choice__remove"
        ) {
          activeTab.click();
          activeTab = null;
        }
      });
    }
  }

  const qid = survey.currentPage?.name;

  if (qid === "q_4_2" || qid === "q_4_3") {
    $("[data-value='1']").text(t("survey.common.not_at_all", { ns: "survey" }));
    $("[data-value='3']").text(t("survey.common.sometimes", { ns: "survey" }));
    $("[data-value='5']").text(t("survey.common.absolutely", { ns: "survey" }));
  }
  if (qid === "q_4_4" || qid === "q_4_5") {
    $("[data-value='1']").text(t("survey.common.not_at_all", { ns: "survey" }));
    $("[data-value='3']").text(t("survey.common.maybe", { ns: "survey" }));
    $("[data-value='5']").text(t("survey.common.definitely", { ns: "survey" }));
  }
  if (qid === "q_4_6") {
    $("[data-value='1']").text(t("survey.common.disagree", { ns: "survey" }));
    $("[data-value='3']").text(t("survey.common.not_sure", { ns: "survey" }));
    $("[data-value='5']").text(t("survey.common.agree", { ns: "survey" }));
  }

  if (survey.currentPage?.chapter === 4 && qid !== "q_4_1") {
    const titleElem = document.querySelector(".sv_q_title");
    titleElem?.parentElement.insertAdjacentElement("beforeend", titleElem);
  }
  document
    .querySelector(".sv_container")
    ?.parentElement.classList.add("fade-in");

  //ADD ARIA LABEL FOR ELEMENT OR

  const elementOr = document.querySelector(".sv_q_radiogroup_or_line");
  elementOr?.setAttribute("aria-label", elementOr.innerText);

  // REMOVE aria-invalid and aria-require from radio element
  let elementRadio = q.htmlElement.getElementsByClassName(
    "sv_q_radiogroup_control_item"
  );

  // elementRadio.setAttribute('aria-label', 'label')

  for (let i = 0; i < elementRadio.length; i++) {
    elementRadio[i].removeAttribute("aria-invalid");
    elementRadio[i].removeAttribute("aria-required");

    let id = elementRadio[i].getAttribute("id");
    let label = elementRadio[i].parentElement;
    label.setAttribute("for", id);

    let ariaValue = elementRadio[i].parentElement.querySelector(
      ".sv_q_radiogroup_label > span:last-child > .sv-string-viewer"
    );
    elementRadio[i].setAttribute("aria-label", ariaValue.innerText);
  }

  // REMOVE aria-invalid and aria-require from checkbox element
  let elementCheckbox = q.htmlElement.getElementsByClassName(
    "sv_q_checkbox_control_item"
  );

  // elementRadio.setAttribute('aria-label', 'label')

  for (let i = 0; i < elementCheckbox.length; i++) {
    elementCheckbox[i].removeAttribute("aria-invalid");
    elementCheckbox[i].removeAttribute("aria-required");
    //elementCheckbox[i].setAttribute("role", "checkbox");

    let id = elementCheckbox[i].getAttribute("id");
    let label = elementCheckbox[i].parentElement;
    label.setAttribute("for", id);

    let ariaValue = elementCheckbox[i].parentElement.querySelector(
      ".sv_q_checkbox_label > span:last-child > .sv-string-viewer"
    );
    elementCheckbox[i].setAttribute("aria-label", ariaValue.innerText);
  }

  //ADD fieldset legend

  const qTitle = document.querySelector(".sv_q_title");

  //Field Search city listbox

  const seatchInput = document.querySelector(".location-search-input");
  seatchInput?.setAttribute("aria-label", qTitle?.innerText);

  const dropdownList = document.querySelector(
    ".autocomplete-dropdown-container"
  );
  dropdownList?.setAttribute("aria-label", qTitle?.innerText);

  const sliderControll = document.querySelector(".noUi-handle");
  sliderControll?.setAttribute("aria-label", qTitle?.innerText);

  //
  const selectPlaceholder = document.querySelector(
    "[role='textbox'] .select2-selection__placeholder"
  );
  if (selectPlaceholder) {
    selectPlaceholder.parentElement.setAttribute(
      "aria-label",
      selectPlaceholder.innerText
    );
  }

  // remove aria-invalid and aria-required from <div>
  const elems = document.querySelectorAll("div[aria-invalid]");
  for (let i = 0; i < elems.length; i++) {
    elems[i].removeAttribute("aria-invalid");
    elems[i].removeAttribute("aria-required");
  }

  // remove unnecessary span[title]
  const elemsTitle = q.htmlElement.querySelectorAll("fieldset span[title]");
  for (let i = 0; i < elemsTitle.length; i++) {
    elemsTitle[i].removeAttribute("title");
  }

  // custom widget "product-selection"
  if (question.customWidgetValue?.name === "product_selection") {
    // move instructions
    const instructions = document.querySelector(".sv_q_instructions");
    const search = document.querySelector(".search-box");

    // move radiogroup with "none"
    const noneQuestion = question.parent.questionsValue.find(
      (element) => element instanceof Survey.QuestionRadiogroupModel
    );
    if (search && noneQuestion) {
      search.after(noneQuestion.rootElement);
    }

    if (search && instructions) {
      search.after(instructions);
    }
  }

  // hide next/prev and draw a different Next button on Easter egg page
  const surveyButtons = document.querySelector(".survey-buttons");
  if (question.page?.isEasterEgg) {
    surveyButtons?.classList.add("hide");
    const nextHtml = `<div class="flex-center action-bar mt-10"><button class="cta cta--primary cta--centered btn--easteregg"><span class="cta__content">
    ${t("survey.common.next", { ns: "survey" })}</span>
    </button></div>`;

    const container = document.querySelector(".sv_row");
    container?.insertAdjacentHTML("beforeend", nextHtml);

    const nextBtn = document.querySelector(".btn--easteregg");

    nextBtn?.addEventListener("click", () => {
      survey.isNextButtonClicked = true;
      if (!survey.nextPage()) {
        survey.isNextButtonClicked = false;
      }
    });
  } else {
    surveyButtons?.classList.remove("hide");
  }
}
